const stripe = {
  title: 'Stripe',

  billing_unavailable:
    "La facturation n'est pas encore disponible pour cet installateur. Veuillez contacter le support.",

  sync: {
    explanation:
      'Ce bouton permet de lancer une synchronisation pour mettre à jour le nombre de portes facturables dans Stripe.',
    button: 'Lancer une synchronisation',
  },
};

export default stripe;
